import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PopupAlert from "../components/PopupAlert";
import GocLeadsComponent from "./GocLeadsComponent";
import FluffyTouchLeadComponent from "./FluffyTouchLeadComponent";
import RepairBuddyLeadComponent from "./RepairBuddyLeadComponent";
import GlazmaLeadComponent from "./GlazmaLeadComponent";

function Dashboard({ role, dataAccessDays, link, companyAccess }) {
  // const link = "https://api.dashboard.bhumu.com"
  // const link = "http://localhost:7051";
  // const link = "http://192.168.1.4:7051";
  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const navigate = useNavigate();

  const logout = async () => {
    try {
      const response = await fetch(`${link}/logout`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-type": "application/json",
        },
      });

      if (response.ok) {
        navigate("/");
      } else {
        alert("Logout Error");
      }
    } catch (error) {
      alert("Server Error");
    }
  };

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const [showlogOut, setShowLogout] = useState(null);

  const [viewCompany, setViewCompany] = useState(companyAccess);

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  return (
    <>
      {showlogOut ? (
        <div className="dboard-log-out-alert-n">
          <PopupAlert
            heading="Are you sure you want to log out?"
            icon="fa-solid fa-right-from-bracket"
            open={setShowLogout}
            action={logout}
          />
        </div>
      ) : (
        ""
      )}

      <div>
        <div className="goc-dash-bord-container">
          <div className="goc-dash-bord-container-main">
            <div className="goc-dashbord-right-side-main-col">
              <div className="goc-dashbord-right-side-main-head">
                <div>
                  <div className="goc-dashbord-top-head-main-txt">
                    {viewCompany}{" "}
                    {role === "admin" ? (
                      <>
                        <div className="fa-solid fa-angle-down"></div>
                        <div className="goc-dashbord-top-head-main-dropdown">
                          <a onClick={() => setViewCompany("Garage On Call")}>
                            Garage On Call
                          </a>
                          <a onClick={() => setViewCompany("Fluffy Touch")}>
                            Fluffy Touch
                          </a>
                          <a onClick={() => setViewCompany("Garage On Call")}>
                            Glazma
                          </a>
                          <a onClick={() => setViewCompany("Garage On Call")}>
                            Repair Buddy
                          </a>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="goc-dashbord-right-head-filter-container">
                  <div
                    className="goc-dashbord-search-filter"
                    onClick={() => setShowLogout(true)}
                  >
                    <i class="fa-solid fa-right-from-bracket"></i>LogOut
                  </div>
                </div>
              </div>

              <div className="goc-dashbord-main-show-data-warpper-row">
                {viewCompany === "Garage On Call" ? (
                  <GocLeadsComponent
                    role={role}
                    dataAccessDays={dataAccessDays}
                    logout={logout}
                  />
                ) : viewCompany === "Repair Buddy" ? (
                  <RepairBuddyLeadComponent
                    role={role}
                    dataAccessDays={dataAccessDays}
                    logout={logout}
                  />
                ) : viewCompany === "Fluffy Touch" ? (
                  <FluffyTouchLeadComponent
                    role={role}
                    dataAccessDays={dataAccessDays}
                    logout={logout}
                  />
                ) : viewCompany === "Glazma" ? (
                  <GlazmaLeadComponent
                    role={role}
                    dataAccessDays={dataAccessDays}
                    logout={logout}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
